// extracted by mini-css-extract-plugin
export var askAiIcon = "_ok-k";
export var category = "_ok-a";
export var categoryHeader = "_ok-f";
export var container = "_ok-0";
export var group = "_ok-b";
export var groupItems = "_ok-g";
export var groupSeparator = "_ok-l";
export var highlight = "_ok-8";
export var loading = "_ok-1";
export var noResults = "_ok-3";
export var placeholder = "_ok-2";
export var resultContent = "_ok-5";
export var resultIcon = "_ok-d";
export var resultItem = "_ok-h";
export var resultMeta = "_ok-9";
export var resultSubtitle = "_ok-7";
export var resultSuffix = "_ok-j";
export var resultTitle = "_ok-6";
export var resultsList = "_ok-4";
export var searchGroup = "_ok-e";
export var selected = "_ok-i";
export var subgroup = "_ok-c";